import { IoIosClose } from 'react-icons/io';
import '../styles/mintcountdown.css';
import { useMap, useMapEvents } from 'react-leaflet/hooks';
import { useState, useEffect } from 'react';
import DetectDevice from './DeviceDetector';

function CountdownTimer({ targetDate }) {
  const calculateTimeLeft = () => {
    const difference = +new Date(targetDate) - +new Date();
    let timeLeft = {};

    if (difference > 0) {
      timeLeft = {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60),
      };
    }

    return timeLeft;
  };

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  useEffect(() => {
    const timerId = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearInterval(timerId);
  }, []);

  return (
    <>
      {timeLeft.days ? (
        <span style={{ color: 'rgb(79, 79, 250)' }}>
          {String(timeLeft.days).padStart(2, '0')}
        </span>
      ) : null}
      {timeLeft.days ? <span style={{ color: '#aebbd2' }}>d </span> : null}

      <span style={{ color: 'rgb(79, 79, 250)' }}>
        {timeLeft.hours ? String(timeLeft.hours).padStart(2, '0') : '00'}
      </span>
      <span style={{ color: '#aebbd2' }}>h </span>

      <span style={{ color: 'rgb(79, 79, 250)' }}>
        {timeLeft.minutes ? String(timeLeft.minutes).padStart(2, '0') : '00'}
      </span>
      <span style={{ color: '#aebbd2' }}>m </span>

      <span style={{ color: 'rgb(79, 79, 250)' }}>
        {timeLeft.seconds ? String(timeLeft.seconds).padStart(2, '0') : '00'}
      </span>
      <span style={{ color: '#aebbd2' }}>s</span>
    </>
  );
}

const MintCountdown = ({
  showBanner,
  setShowBanner,
  bannerMessage,
  redactNFTs,
}) => {
  const map = useMap();

  return (
    <div
      className="mint-countdown"
      style={{
        pointerEvents: showBanner && !redactNFTs ? 'auto' : 'none',
        opacity: showBanner && !redactNFTs ? 1 : 0,
      }}
    >
      <IoIosClose
        className="mint-countdown-close"
        style={{
          pointerEvents: showBanner && !redactNFTs ? 'auto' : 'none',
          opacity: showBanner && !redactNFTs,
        }}
        onClick={() => {
          setShowBanner(0);
        }}
      />

      {bannerMessage ? (
        <span>
          {/* {DetectDevice ? <br></br> : null} */}
          TODEM will launch in
          <br></br>
          <span style={{ color: 'rgb(160, 160, 255)' }}>early July</span>
          {/* {DetectDevice ? <br></br> : null}
                    &nbsp;(<CountdownTimer targetDate={'July 11, 2023 15:00:00 GMT'}/>). */}
          <br></br>
          Minting is paused. Until then, stay tuned to <br></br>
          <a
            href="https://twitter.com/latentculture"
            rel="noreferrer"
            target="_blank"
          >
            @latentculture
          </a>{' '}
          and EXPLORE!
        </span>
      ) : (
        <span>
          Our pre-launch beta period ends{' '}
          <span style={{ color: 'rgb(160, 160, 255)' }}>
            Tues, June 6, 8pm GMT
          </span>{' '}
          and minting will pause. TODEM will formally launch on{' '}
          <span style={{ color: 'rgb(160, 160, 255)' }}>
            Tues, June 27, 8pm GMT
          </span>
          .
        </span>
      )}
    </div>
  );
};

export default MintCountdown;
